import { render, staticRenderFns } from "./move-type-tab.vue?vue&type=template&id=5d364591"
import script from "./move-type-tab.vue?vue&type=script&lang=js"
export * from "./move-type-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports